<template>
    <div ref="navbar" class="TopToolbar flex_b_c" :style="{background: defaultTheme}">
        <div class="flex_l_c ">
            <div class="sidebarFold" @click="sidebarFold = !sidebarFold">
                <i :class="sidebarFold ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            </div>
            <div class="logoBox flex_c_c pointer" @click="toHome">
                <img v-if="tenantInfo.productLogUrl" :src="tenantInfo.productLogUrl" class="logo_alone">
                <div class="name">{{tenantInfo.productName || ''}}</div>
            </div>
            <div class="flex_l_c topMenu">
                <el-menu :default-active="topMenuActiveIndex" ref="topMenu" mode="horizontal">
                    <el-menu-item class="el_menu_item" v-for="menu in topMenuList"
                                  :index="menu.id"
                                  :key="menu.id"
                                  @click="showLeftMenu(menu)"
                                  :ref="menu.id"
                                  :menu="menu">
                        <i :class="`${menu.icon}`" style="display: inline-block!important;"></i>
                        {{ menu.name }}
                    </el-menu-item>
                    <el-submenu index="2" v-if="topHideMenuList.length != 0">
                        <template slot="title">更多</template>
                        <el-menu-item v-for="menu in topHideMenuList"
                                      :index="menu.id"
                                      :key="menu.id"
                                      :ref="menu.id"
                                      @click="showLeftMenu(menu)"
                                      :menu="menu">
                            <i :class="`${menu.icon}`"
                               style="display: inline-block!important;"></i>
                            {{ menu.name }}
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
        <el-menu mode="horizontal">
            <el-menu-item v-if="hasPermission('index:homeEntrance')" @click="goToHomeSearch()">
                <i class="el-icon-search"></i>
            </el-menu-item>
            <el-menu-item @click="toNotifyList">
                <el-popover
                        :disabled="!messagedataList.length"
                        placement="bottom-end"
                        width="300"
                        trigger="hover"
                >
                    <el-badge slot="reference" :value="total" class="item">
                        <i class="el-icon-bell"></i>
                    </el-badge>
                    <div class="message">
                        <div class="flex_b_c b_b messageTitle">
                            <div>消息</div>
                            <div class="allMessage" @click="setAllType()">全部设为已读</div>
                        </div>
                        <div class="messageList">
                            <div v-for="(item,index) in messagedataList" :key="item.id"
                                 @click="goToMessData(item,index)"
                                 class="flex_l_t itemMessage">
                                <div class="unread">
                                    <div></div>
                                </div>
                                <div>
                                    <div class="omit messageContent">{{ item.messageContent }}</div>
                                    <div>{{ item.messageData }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="text_center b_t messageBot" @click="toNotifyList()">查看所有消息</div>
                    </div>
                </el-popover>
            </el-menu-item>
            <el-menu-item>
                <el-dropdown :show-timeout="0" placement="bottom">
                        <span class="el-dropdown-link">
                            <el-avatar size="medium" :src="userAvatar"></el-avatar>
                            <span class="userName">{{ userName }}</span>
                        </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="personalCenter()">个人中心</el-dropdown-item>
                        <el-dropdown-item @click.native="logoutHandle()">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-menu-item>
            <el-menu-item v-if="tenantList.length > 1">
                <el-dropdown :show-timeout="0" placement="bottom">
                    <span class="changeBtn">切换</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in tenantList" :key="index" @click.native="changeTenant(item.tenantId)">{{item.tenantName}} <el-link :underline="false" v-if="tenantInfo.temporaryAuthorityId == item.tenantId" icon="el-icon-check"></el-link></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-menu-item>
            <el-menu-item @click="showRight">
                <i class="el-icon-more" @click="showRight"></i>
            </el-menu-item>
        </el-menu>
        <see-message ref="seeMessage" @switchData="switchDetail"></see-message>
    </div>
</template>

<script>
    import SeeMessage from "@/views/modules/sys/mageCenter/seeMessage.vue";

    export default {
        components: {SeeMessage},
        data() {
            return {
                tenantInfo: JSON.parse(sessionStorage.getItem("tenantInfo")) || {},
                activeIndex: '',
                topMenuList: [],
                topHideMenuList: [],
                allMenuList: [],
                detailCurr: 0,
                tenantList: [], // 租户
            }
        },
        computed: {
            // 顶部选中菜单
            topMenuActiveIndex: {
                get() {
                    return this.$store.state.common.topMenuActiveIndex
                },
                set(val) {
                    this.$store.commit('common/updateTopMenuActiveIndex', val)
                }
            },
            // 菜单缩放
            sidebarFold: {
                get() {
                    return this.$store.state.common.sidebarFold
                },
                set(val) {
                    this.$store.commit('common/updateSidebarFold', val)
                }
            },
            // 页签
            mainTabs: {
                get() {
                    return this.$store.state.common.mainTabs
                },
                set(val) {
                    this.$store.commit('common/updateMainTabs', val)
                }
            },
            // 主题色
            defaultTheme() {
                return this.$store.state.config.defaultTheme
            },
            // 导航模式
            defaultLayout() {
                return this.$store.state.config.defaultLayout
            },
            sockTypeData() {
                return this.$store.state.common.sockType
            },
            sockPushData() {
                return this.$store.state.common.sockPush
            },
            // 用户名
            userName: {
                get() {
                    return this.$store.state.user.userInfo.name
                }
            },
            // 用户头像
            userAvatar: {
                get() {
                    return this.$store.state.user.userInfo.image
                }
            },
            // 用户id
            userId: {
                get() {
                    return this.$store.state.user.userInfo.id
                }
            },

            //未读信息
            messagedataList() {
                return this.$store.state.user.userMessage.list || []
            },
            total() {
                return this.$store.state.user.userMessage.total
            },
        },
        created() {
            this.allMenuList = JSON.parse(sessionStorage.getItem('allMenuList') || '[]')
            if (this.defaultLayout === 'top') {
                this.topMenuActiveIndex = this.allMenuList[0].id
                this.showLeftMenu(this.allMenuList[0])
            } else {
                this.$store.commit('common/updateLeftMenuList', this.allMenuList)
            }
        },
        mounted() {
            this.getTenant()
            this.resetDocumentClientHeight();
            if (this.defaultLayout === 'top') {
                this.fixTopMenu()
            }
            //更新我的未读信息
            this.$store.commit('user/updateUserMessage')
        },
        watch: {
            // 顶部选中菜单
            topMenuActiveIndex(val) {
                this.topMenuList.forEach((menu) => {
                    if (menu.id === val) {
                        this.showLeftMenu(menu)
                    }
                })
                this.topHideMenuList.forEach((menu) => {
                    if (menu.id === val) {
                        this.showLeftMenu(menu)
                    }
                })
            },
            // 导航模式
            defaultLayout() {
                if (this.defaultLayout === 'top') {
                    let needSetLeft = true
                    this.allMenuList.forEach((item) => {
                        if (item.id === this.topMenuActiveIndex) {
                            this.showLeftMenu(item)
                            needSetLeft = false
                        }
                    })
                    if (needSetLeft) {
                        this.topMenuActiveIndex = this.allMenuList[0].id
                        this.showLeftMenu(this.allMenuList[0])
                    }
                    this.fixTopMenu()
                } else {
                    this.topMenuList = []
                    this.topHideMenuList = []
                    this.$store.commit('common/updateLeftMenuCategory', '')
                    this.$store.commit('common/updateLeftMenuList', this.allMenuList)
                }
            },
            // sockTypeData(){
            //     this.getTotal()
            // },
            // sockPushData(e){
            //     console.log("推送消息：",e);
            //     let that=this;
            //     let id = JSON.parse(sessionStorage.getItem('userInfo')).id
            //     e.split(",").forEach(function (v) {
            //         if(id==v){
            //             that.getTotal()
            //         }
            //     })
            // }
        },

        methods: {
            // 获取租户
            getTenant() {
                this.$axios(this.api.user.getByUserId, {userId: this.userId}).then(res => {
                    if (res.status) {
                        this.tenantList = res.data
                    }
                })
            },
            // 切换租户
            changeTenant(id) {
                if(this.tenantId == id) {
                    return
                }
                this.$emit('switchTenants', true)
                this.$axios(this.api.user.switchTenants, {tenantId: id}).then(data => {
                    if (data.status) {
                        sessionStorage.setItem('token', data.data.token)
                        document.cookie = `satoken=${data.data.token}`
                        this.$store.commit('user/updateUser', data.data)
                        this.$store.dispatch('tagsView/delAllViews')
                        this.socketApi.initWebSocket()
                        this.$router.push({name: 'menuHome'})
                        window.location.reload()
                    } else {
                        this.$message({
                            message: data.msg,
                        });
                    }
                })
            },
            //消息详情 0上一条 1下一条切换
            switchDetail(num) {
                if (num == 0 && this.detailCurr == 1) {
                    this.$message('已是第一条')
                    return
                }
                if (num == 1 && (this.detailCurr) == this.total) {
                    this.$message('已是最后一条')
                    return
                }
                if (num == 1 && (this.detailCurr) == 99) {
                    this.$message('已是最后一条')
                    return
                }
                if (num == 0) {
                    this.detailCurr--
                } else {
                    this.detailCurr++
                }
                this.$axios(this.api.allCommon.commonMessageSelectMessageList, {
                    messageClassification: '',
                    messageContent: '',
                    messageType: '',
                    messageStatus: '0',
                    current: this.detailCurr,
                    size: 1,
                }).then(data => {
                    if (data.status) {
                        this.$refs.seeMessage.init(data.data.records[0])
                    } else {
                        this.$message.error(data.msg);
                    }
                })
            },

            // 个人中心
            personalCenter() {
                let alMmenu = JSON.stringify(this.$store.state.common.leftMenuList)
                if (alMmenu.indexOf('/sys/personal/myInfo') == -1) {
                    this.$message.warning('未分配个人中心权限，请联系管理员授予权限！')
                } else {
                    this.$router.push('/sys/personal/myInfo')
                }
                // this.$emit('showPersonal', true);
            },
            // 通知
            toNotifyList() {
                this.$router.push('/sys/mageCenter/mageCenter')
            },

            //全部设为已读
            setAllType() {
                this.$confirm(`您是否确认消息全部已读?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.allCommon.commonMessageBatchRead, [], 'post').then(data => {
                        if (data.status) {
                            this.$message.success('全部已读成功');
                            this.$store.commit('user/updateUserMessage')
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
                })
            },

            //查看单个消息
            goToMessData(row, index) {
                this.detailCurr = index + 1
                this.$refs.seeMessage.init(row)
            },

            // 退出
            logoutHandle() {
                this.$confirm(`确定进行[退出]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.user.loginOut, {}, 'get').then(data => {
                        if (data.status) {
                            sessionStorage.removeItem('userInfo')
                            sessionStorage.removeItem('dictList')
                            sessionStorage.removeItem('allMenuList')
                            sessionStorage.removeItem('dynamicMenuRoutes')
                            sessionStorage.removeItem('token')
                            sessionStorage.removeItem('permissions')
                            this.$router.replace({name: 'login'});
                            window.location.reload();
                        }
                    })
                })
            },
            fixTopMenu() {
                let width = window.getComputedStyle(this.$refs.navbar).width
                let size = (parseInt(width) - 739) / 180
                this.topMenuList = []
                this.topHideMenuList = []
                this.allMenuList.forEach((item, index) => {
                    if (index < size - 1) {
                        this.topMenuList.push(item)
                    } else {
                        this.topHideMenuList.push(item)
                    }
                })
            },
            // 重置窗口可视高度
            resetDocumentClientHeight() {
                window.onresize = () => {
                    if (this.$refs.navbar) {
                        if (this.defaultLayout === 'top') {
                            this.fixTopMenu()
                        }
                    }
                }
            },
            showRight() {
                this.$emit('showRight', true)
            },
            showLeftMenu(menu) {
                this.$store.commit('common/updateLeftMenuList', menu.children)
                this.$store.commit('common/updateLeftMenuCategory', menu.name)
            },
            toHome() {
                this.$router.push('/menuHome')
            },


            //去首页
            goToHomeSearch() {
                window.open(this.$router.resolve({path: "/academic/home/index",}).href, '_blank')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .sidebarFold {
        color: #ffffff;
        font-size: 24px;
        margin: 0 20px;
        cursor: pointer;
    }
    .changeBtn {
        color: #ffffff;
        font-size: 14px;
    }
    .userName {
        color: #ffffff;
        padding-left: 10px;
        font-size: 14px;
    }

    .el-badge {
        display: inline !important;
    }

    .message {
        font-size: 13px;
    }

    .messageTitle {
        padding-bottom: 5px;
    }

    .messageList {
        max-height: 235px;
        overflow-y: auto;

        .itemMessage {
            margin-top: 10px;
            cursor: pointer;

            .messageContent {
                overflow: hidden;
                width: 240px;
            }
        }
    }

    .unread {
        width: 20px;
        text-align: center;

        div {
            margin-top: 10px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: red;
            margin-right: 8px;
        }
    }

    .allMessage {
        cursor: pointer;
        color: #1e88e5;
    }

    .messageBot {
        cursor: pointer;
        margin-top: 10px;
        padding-top: 5px;
        color: #1e88e5;
    }
</style>
